module.exports = __webpack_public_path__ + "img/andrew-pro.1ef62db9.jpg";